import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
@Component({})
export default class IECheckComponent extends Vue {
    public isInternetExplorer : boolean = false;
    private saveStateKey : string = "HideInternetExplorerWarning";
    public isHidden : boolean = true;

    mounted(){
        this.isInternetExplorer=/msie\s|trident\//i.test(window.navigator.userAgent);  
        this.isHidden = localStorage.getItem(this.saveStateKey) == '1'; 
    }
  

    hide(){
        localStorage.setItem(this.saveStateKey,'1');
        this.isHidden=true;
    }
}
Vue.component('ie-check-component', IECheckComponent);
